export const fallbackImage = 'https://media.api-sports.io/football/teams/25952.png'